export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import type {FileCardListItem} from 'kpc';

const imageSrc = 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80';

interface Props {
    imageFiles: FileCardListItem[]
    fileItems: FileCardListItem[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            imageFiles: [
                {
                    key: 'img-1',
                    name: '门店照片-01.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 680,
                },
                {
                    key: 'img-2',
                    name: '门店照片-02.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 520,
                },
                {
                    key: 'img-3',
                    name: '门店照片-03.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 610,
                },
                {
                    key: 'img-4',
                    name: '门店照片-04.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 560,
                },
                {
                    key: 'img-5',
                    name: '门店照片-05.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 590,
                },
                {
                    key: 'img-6',
                    name: '门店照片-01.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 680,
                },
                {
                    key: 'img-7',
                    name: '门店照片-02.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 520,
                },
                {
                    key: 'img-8',
                    name: '门店照片-03.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 610,
                },
                {
                    key: 'img-9',
                    name: '门店照片-04.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 560,
                },
                {
                    key: 'img-10',
                    name: '门店照片-05.jpg',
                    src: imageSrc,
                    status: 'done',
                    byte: 1024 * 590,
                },
            ],
            fileItems: [
                {
                    key: 'file-1',
                    name: '镜头脚本.pdf',
                    type: 'file',
                    byte: 1024 * 120,
                    src: 'https://example.com/script.pdf',
                },
                {
                    key: 'file-2',
                    name: '品牌规范.pdf',
                    type: 'file',
                    byte: 1024 * 1024 * 1.2,
                    src: 'https://example.com/brand-guide.pdf',
                },
            ],
        } as Props;
    }
}